var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:_vm.active+'-active'},[_c('prime',[(_vm.projects)?_c('project-list',{attrs:{"projects":_vm.projects,"detail":""}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }